<template>
  <div class="block-2">
    <div class="content">
      <div class="title" v-if="showTitle !== false">
        <h1>{{title === undefined ? 'Наши услуги' : title}}</h1>
      </div>

      <!-- Главная плашка (на весь ряд) -->
        <a href="https://lab-tehservis.tilda.ws" target="_blank" class="services_item-wide">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/vash-teg'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <!-- вставить иконку -->
              <img src="@/assets/img/new-service4.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Лаборатория неразрушающего контроля</p>  


              
              <div class="orange-line"></div>
            </div>
            <div class="orange-line orange-line_item"></div>
          </div>
        </a>

      <div class="services">

        <router-link to="/service/abz">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/abz'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/item-factory.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Запчасти <br>к асфальто-бетонным заводам</p> 
              <!-- показывается без наведения -->
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

        <router-link to="/service/metal-processing">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/metal-processing'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/item-lathe.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Механическая <br>обработка металла</p>
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

        <router-link to="/service/groove-of-bandages">
          <div class="services_item" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/item-sb.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Проточка бандажей и катков сушильного барабана</p>
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

        <router-link to="/service/welding-of-metal-structures">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/welding-of-metal-structures'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/item-welding.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Сварка <br>металлоконструкций</p>
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

        <router-link to="/service/road-construction-machinery">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/road-construction-machinery'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/item-excavator.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Запчасти к дробилкам и дорожно-строительной технике</p>
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

        <router-link to="/service/repair-dryer-drum">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/repair-dryer-drum'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/repair-dryer.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Кап. ремонт <br>сушильных барабанов</p>
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

        <router-link to="/service/repair-dust-collector">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/repair-dust-collector'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/repair-dust.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Кап. ремонт <br>пылеулавливателей</p>
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

        <router-link to="/service/rvs">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/rvs'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/rvz.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Производство и монтаж <br>РВС</p>
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

        <router-link to="/service/other">
          <div class="services_item" :class="{'services_item-active': currentRoute === '/service/other'}" @click="emitClosePopup()">
            <div class="services_item_image">
              <img src="@/assets/img/item-file.svg" alt="">
            </div>
            <div class="services_item_text">
              <p>Показать другие <br>услуги</p>
              <div class="orange-line"></div>
            </div>
            <!-- показывается при наведении -->
            <div class="orange-line orange-line_item"></div>
          </div>
        </router-link>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'block-2',
  props: ['showTitle', 'title'],
  computed: {
    currentRoute () {
      return this.$route.path
    }
  },
  methods: {
    emitClosePopup () {
      this.$emit('closeMenuFromHeader')
    }
  }
}
</script>



<style lang="scss" scoped>


@import "~@/assets/styles/variables.scss";

.block-2 {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: $color-gray-background;

  .content {
    width: $global-content-width;
    padding-bottom: 60px;

    .title {
      margin-top: 100px;
      width: 100%;
    }

    // Стили для широкой плашки (она изолированна (НЕ МЕНЯТЬ, А ТО ВСЁ СЛОМАЕТСЯ))
    .services_item-wide {
      display: block;
      width: 100%;
      margin-top: 30px;
      text-decoration: none;
      color: inherit;
      
      .services_item {
        width: 100%; 
        height: 216px; 
        background-color: white;
        box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: row; 
        align-items: center; 
        gap: 35px; 
        padding: 0 40px; 
        transition: all 0.3s;
        position: relative;
        box-sizing: border-box;

        .services_item_image {
          width: 100px;  
          height: 100px; 
          flex-shrink: 0;
          
          img {
            width: 100%;
            height: 100%;
            object-fit: contain; 
          }
        }

        &_text {
          margin-top: 0; 
          p {
            font-style: normal;
            font-weight: bold;
            font-size: 22px; 
            line-height: 28px;
            transition: all 0.3s;
          }
        }

        .orange-line_item {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 0;
          background-color: #ff6b00; 
          transition: all 0.3s;
        }
      }
      
      &:hover {
        .services_item {
          cursor: pointer;
          background-color: $color-light-yellow;
          
          .orange-line_item {
            width: 6px;
          }
        }
      }
    }

    // Старая сетка возвращается к исходному состоянию без изменений
    .services {
      margin-top: 20px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      &_item {
        width: 390px;
        background-color: white;
        margin-top: 30px;
        box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        padding: 25px 25px;
        transition: all 0.3s;
        position: relative;

        &_image {
          width: 64px;
          height: 64px;
        }

        &_text {
          margin-top: 30px;
          position: relative;
          p {
            transition: all 0.3s;
            padding-left: 15px;
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 24px;
          }

          .orange-line {
            transition: all 0.3s;
            width: 5px;
          }
        }

        .orange-line_item {
          transition: all 0.3s;
          width: 0;
        }
      }

      &_item:hover {
        cursor: pointer;
        background-color: $color-light-yellow;

        .services_item_text {
          p {
            transition: all 0.3s;
            padding-left: 0;
          }
          .orange-line {
            transition: all 0.3s;
            width: 0;
            opacity: 0;
          }
        }

        .orange-line_item {
          width: 6px;
        }
      }

      &_item-active {
        background-color: $color-light-yellow;

        .services_item_text {
          p {
            transition: all 0.3s;
            padding-left: 0;
          }
          .orange-line {
            transition: all 0.3s;
            width: 0;
            opacity: 0;
          }
        }
        .orange-line_item {
          width: 6px;
        }
      }
    }

  }

  @media (min-width: 960px) and (max-width: 1229px) {
    .content {
      width: $global-content-width-960;

      .services {
        &_item {
          width: 450px;
        }
      }
    }
  }

  @media (min-width: 690px) and (max-width: 959px) {
    .content {
      width: $global-content-width-690;
      padding-bottom: 45px;

      .services {
        &_item {
          width: 330px;

          &_text {
            p {
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  @media (min-width: 510px) and (max-width: 689px) {
    .content {
      width: $global-content-width-510;
      padding-bottom: 40px;

      .title {
        margin-top: 80px;
      }

      .services {
        margin-top: 10px;
        &_item {
          width: 240px;

          &_text {
            p {
              font-weight: bold;
              font-size: 14px;
              line-height: 19px;
            }
          }
        }
      }
    }
  }

  @media (min-width: 290px) and (max-width: 509px) {
    .content {
      width: $global-content-width-290;
      padding-bottom: 40px;

      .title {
        margin-top: 60px;
      }

      .services {
        margin-top: 0;

        a {
          width: 100%;
        }

        &_item {
          width: 100%;
          height: 77px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 18px 25px 18px 15px;

          &_image {
            width: 40px;
            height: 40px;
            flex: none;
          }

          &_text {
            margin-top: 0;
            width: 190px;

            p {
              font-style: normal;
              font-weight: bold;
              font-size: 14px;
              line-height: 19px;
              br {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>


/*@import "~@/assets/styles/variables.scss";

.block-2 {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: $color-gray-background;

  .content {
    width: $global-content-width;
    padding-bottom: 60px; // половина отсутпа до третьего блока

    .title {
      margin-top: 100px;
      width: 100%;
    }

    .services {
      margin-top: 20px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      &_item-wide {
        width: 100%; /* Занимает всю ширину контейнера (весь ряд) */
        
        .services_item {
          width: 100%; /* Сбрасываем фиксированные 390px */
          height: 216px;
          box-sizing: border-box;
          flex-direction: row; /* Выстраиваем иконку и текст горизонтально */
          align-items: center; /* Центрируем иконку и текст по вертикали */
          gap: 25px; /* Расстояние между иконкой и текстом */
          padding: 0px 40px;

          .services_item_image {
            width: 100px;  // 64px дефолт  
            height: 100px; // 64px дефолт
            
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;

          &_text {
            margin-top: 0; /* Убираем верхний отступ, который был у квадратных плиток */
            
            p {
              padding-left: 0; 
              font-size: 22px; /* Слегка увеличим шрифт, так как места в строке теперь много */
              line-height: 28px;
            }
            .orange-line {
              display: none;
            }
          }
        }
        
        /* Эффект наведения для широкой плашки */
        &:hover {
          .services_item {
            background-color: $color-light-yellow;
            
            .orange-line_item {
              width: 6px;
            }
          }
        }
      }


      &_item {
        width: 390px;
        // height: 216px;
        background-color: white;
        margin-top: 30px;
        box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        padding: 25px 25px;
        transition: all 0.3s;
        position: relative;

        &_image {
          width: 64px;
          height: 64px;
        }

        &_text {
          margin-top: 30px;
          position: relative;
          p {
            transition: all 0.3s;
            padding-left: 15px;
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 24px;
          }

          .orange-line {
            transition: all 0.3s;
            width: 5px;
          }
        }

        .orange-line_item {
          transition: all 0.3s;
          width: 0;
        }

      }

      &_item:hover {
        cursor: pointer;
        background-color: $color-light-yellow;

        .services_item_text {
          p {
            transition: all 0.3s;
            padding-left: 0;
          }
          .orange-line {
            transition: all 0.3s;
            width: 0;
            opacity: 0;
          }
        }

        .orange-line_item {
          width: 6px;
        }
      }

      &_item-active {
        background-color: $color-light-yellow;

        .services_item_text {
          p {
            transition: all 0.3s;
            padding-left: 0;
          }
          .orange-line {
            transition: all 0.3s;
            width: 0;
            opacity: 0;
          }
        }
        .orange-line_item {
          width: 6px;
        }
      }
    }
  }
  @media (min-width: 960px) and (max-width: 1229px) {
    .content {
      width: $global-content-width-960;

      .services {
        &_item {
          width: 450px;
        }
      }
    }
  }
  @media (min-width: 690px) and (max-width: 959px) {
    .content {
      width: $global-content-width-690;
      padding-bottom: 45px;

      .services {
        &_item {
          width: 330px;

          &_text {
            p {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  @media (min-width: 510px) and (max-width: 689px) {
    .content {
      width: $global-content-width-510;
      padding-bottom: 40px;

      .title {
        margin-top: 80px;
      }

      .services {
        margin-top: 10px;
        &_item {
          width: 240px;

          &_text {
            p {
              font-weight: bold;
              font-size: 14px;
              line-height: 19px;
            }
          }
        }
      }
    }
  }
  @media (min-width: 290px) and (max-width: 509px) {
    .content {
      width: $global-content-width-290;
      padding-bottom: 40px;

      .title {
        margin-top: 60px;
      }

      .services {
        margin-top: 0;

        a {
          width: 100%;
        }

        &_item {
          width: 100%;
          height: 77px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 18px 25px 18px 15px;

          &_image {
            width: 40px;
            height: 40px;
            flex: none;
          }

          &_text {
            margin-top: 0;
            width: 190px;

            p {
              font-style: normal;
              font-weight: bold;
              font-size: 14px;
              line-height: 19px;
              br {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}